export default "__VITE_ASSET__Cj$nXWj5__"